import _Promise from 'babel-runtime/core-js/promise';
import Lockr from 'lockr';
import store from '@/store';

/** 移除授权信息 */
export function removeAuth() {
  return new _Promise(function (resolve) {
    Lockr.rm('loginState'); //缓存中移除token
    Lockr.rm('loginUserInfo'); //缓存中移除token
    Lockr.rm('permissionArr'); //缓存中移除token
    Lockr.rm('LoginInfo'); //缓存中移除LoginInfo
    Lockr.rm('loginUser'); //缓存中移除loginUser
    resolve(true);
  });
}
/** 获取登录成功信息 */
export function hasLogin() {
  if (Lockr.get('loginState')) {
    var userInfo = Lockr.get('loginUserInfo');
    var permissionArr = Lockr.get('permissionArr');
    if (userInfo) {
      store.commit('SET_USERINFO', userInfo);
      store.commit('SET_PEIMISSIONARR', permissionArr);
      // store.dispatch('setMenu')
      return true;
    }
  }
  return false;
}